import { render, staticRenderFns } from "./KbankQrcode.vue?vue&type=template&id=1e319bf4&scoped=true"
import script from "./KbankQrcode.vue?vue&type=script&lang=js"
export * from "./KbankQrcode.vue?vue&type=script&lang=js"
import style0 from "./KbankQrcode.vue?vue&type=style&index=0&id=1e319bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e319bf4",
  null
  
)

export default component.exports